<template>
  <div>
    <div class="query-container" style="margin-bottom: 10px">
      <el-form inline class="form" size="mini">
        <el-row>
          <el-col :span="8">
            <el-form-item label="营销单元编码">
              <el-input v-model="queryForm.sobid" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="营销单元名称">
              <el-input v-model="queryForm.mc_short" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-button size="mini" icon="el-icon-refresh-right" @click="handleReset">重置</el-button>
        <el-button size="mini" icon="el-icon-search" type="primary" @click="handleSearch">查询</el-button>
      </el-form>
    </div>
    <vxe-grid
      ref="xTableSaleCenter"
      class="table-block"
      border
      :highlight-hover-row="true"
      resizable
      :show-overflow="true"
      height="auto"
      max-height="500"
      align="center"
      size="mini"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :empty-render="{name: 'NotData'}"
      :toolbar-config="{ custom: false }"
      :edit-config="{ trigger: 'manual', mode: 'row' }"
      :columns="columns"
      :data="tableData"
      @cell-dblclick="cellClick"
    />
  </div>
</template>

<script>
import { apiGetOrgOrBase } from '@/api/sap/common-sap'

export default {
  data() {
    return {
      queryForm: {
        sobid: '',
        mc_short: ''
      },
      allData: [],
      columns: [
        { type: 'checkbox', title: '', field: '', width: 50 },
        { field: 'SOBID', title: '营销单元编码', width: 120 },
        { field: 'MC_SHORT', title: '营销单元名称' }
      ],
      tableData: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const { DATA } = await apiGetOrgOrBase()
      this.allData = DATA || []
      this.filterData()
    },
    filterData() {
      let filtered = [...this.allData]
      
      if (this.queryForm.sobid) {
        filtered = filtered.filter(item => 
          item.SOBID && item.SOBID.toString().includes(this.queryForm.sobid)
        )
      }
      
      if (this.queryForm.mc_short) {
        filtered = filtered.filter(item => 
          item.MC_SHORT && item.MC_SHORT.toString().includes(this.queryForm.mc_short)
        )
      }
      
      this.tableData = filtered
    },
    handleSearch() {
      this.filterData()
    },
    handleReset() {
      this.queryForm = {
        sobid: '',
        mc_short: ''
      }
      this.filterData()
    },
    cellClick({ row, rowIndex, column }) {
      this.$refs.xTableSaleCenter.setCheckboxRow(row, true)
    },
    submitForm() {
      return new Promise(r => {
        r(this.$refs.xTableSaleCenter.getCheckboxRecords())
      })
    }
  }
}
</script>

<style scoped>
.query-container {
  .el-form {
    .el-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      & + .el-button {
        margin-left: 8px;
      }
      i {
        line-height: 1;
        vertical-align: middle;
      }
      span {
        line-height: 1;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product-manage/components/SaleCenter.vue